import { InstrumentInterestAccrualReducerDispatch, InstrumentInterestAccrualReduxState, InstrumentInterestAccrualReduxTypes } from "./types";

const INSTRUMNET_INIT_STATE = {
  loading: false,
  data: {
    metadata: {
      totalCount: 0,
      currentPageRecords: 0,
      totalPages: 0,
      links: {
        self: null,
        first: null,
        previous: null,
        next: null,
        last: null
      }
    },
    records: []
  },
  error: null
};

const IntrumenetInterestAccrualsReducer = (state: InstrumentInterestAccrualReduxState = INSTRUMNET_INIT_STATE, action: InstrumentInterestAccrualReducerDispatch) => {
  switch (action.type) {
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUALS: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUALS_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUALS_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case InstrumentInterestAccrualReduxTypes.RESET:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};



const IntrumenetInterestAccrualReducer = (state: InstrumentInterestAccrualReduxState = INSTRUMNET_INIT_STATE, action: InstrumentInterestAccrualReducerDispatch) => {
  switch (action.type) {
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUAL: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUAL_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUAL_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case InstrumentInterestAccrualReduxTypes.RESET:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};
export { IntrumenetInterestAccrualsReducer ,IntrumenetInterestAccrualReducer};
